export const globalServicesManager = {
  header: {
    title: "الخدمات والتجارب",
    description: "قائمة واحدة لحسابك كله. اكتب كل خدمة مرة واحدة وحدّد في أي إعلانات تُقدَّم.",
  },

  toolbar: {
    info: "ما تنشئه هنا يظهر في <strong>محرك الحجز</strong> وفي <strong>موقعك</strong>، في الإعلانات التي تحدّدها.",
    newService: "خدمة جديدة",
  },

  loading: "جارٍ تحميل الخدمات…",

  empty: {
    title: "لا توجد خدمات بعد",
    description: "توصيل، جولة مع مرشد، سلة ترحيب… يضيفها الضيف أثناء الحجز.",
    create: "أنشئ الأولى",
  },

  status: {
    active: "نشطة",
    paused: "متوقفة",
  },

  price: {
    onRequest: "عند الطلب",
    free: "مجاناً",
  },

  assign: {
    title: "في أي إعلانات تُقدَّم",
    listingsLabel: "إعلاناتك",
    selectAll: "تحديد الكل",
    clearAll: "إلغاء تحديد الكل",
    inAll: "في كل الإعلانات",
    inSome: "في {n} من {total}",
    units: "{n} وحدات",
    pickRooms: "اختيار الغرف",
    hideRooms: "إخفاء الغرف",
    roomsHint: "حدّد الغرف التي تُقدَّم فيها فقط. إن لم تحدّد أيًا منها، تُقدَّم في كلها.",
    inRooms: "في غرفة واحدة | في {count} غرف",
    unassigned: "غير مُسنَد",
    helperNone: "من دون تحديد أي شيء، لا تُقدَّم هذه الخدمة في أي مكان.",
    roomsChecked: "واحدة محدَّدة · مسح | {count} محدَّدة · مسح",
    andMore: "‎+1 أخرى | ‎+{count} أخرى",
    helper: "إذا لم تحدّد أي إعلان، تُقدَّم الخدمة في جميع إعلاناتك.",
  },

  actions: {
    edit: "تعديل",
    delete: "حذف",
    cancel: "إلغاء",
    save: "حفظ",
  },

  delete: {
    title: "حذف الخدمة",
    text: "لن تعود «{name}» تُقدَّم في أي إعلان. لا يمكن التراجع عن ذلك.",
    accept: "نعم، احذف",
  },

  saved: {
    assign: "تم تحديث الإعلانات",
    state: "تم تحديث الخدمة",
    deleted: "تم حذف الخدمة",
  },

  errors: {
    load: "تعذّر تحميل خدماتك.",
    assign: "تعذّر حفظ الإعلانات.",
    state: "تعذّر تغيير الخدمة.",
    delete: "تعذّر حذف الخدمة.",
  },
};
